import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { Reveal } from "@/components/home/homeUi";

const VIDEO_ID = "3G4qiIIFyaw";

export default function HomeVideo() {
  const [playing, setPlaying] = useState(false);
  return (
    <section
      data-testid="home-video"
      aria-label="Bemutatkozó videó"
      className="px-5 md:px-10 pb-8 md:pb-10"
    >
      <Reveal className="max-w-5xl mx-auto">
        <div
          className="relative p-2 md:p-3 rounded-[22px] border border-hairline bg-warm"
          style={{ boxShadow: "0 30px 70px -45px rgba(160, 122, 40, 0.45)" }}
        >
          <div className="relative w-full aspect-video overflow-hidden rounded-[16px] bg-tinted">
            {playing ? (
              <iframe
                data-testid="home-video-iframe"
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
                title="Szász-Tóth Enikő — bemutatkozó videó"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            ) : (
              <button
                type="button"
                data-testid="home-video-play"
                onClick={() => setPlaying(true)}
                aria-label="Bemutatkozó videó lejátszása"
                className="group absolute inset-0 w-full h-full"
              >
                <img
                  src="/images/home-video-poster.jpg"
                  data-testid="home-video-poster"
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.02]"
                  loading="lazy"
                />
                <span
                  aria-hidden="true"
                  className="absolute inset-0"
                  style={{ background: "linear-gradient(180deg, rgba(42,42,42,0) 50%, rgba(42,42,42,0.25) 100%)" }}
                />
                <span
                  aria-hidden="true"
                  className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center transition-transform duration-500 group-hover:scale-105"
                  style={{
                    background: "rgba(249,248,246,0.92)",
                    boxShadow: "0 0 0 10px rgba(249,248,246,0.25)",
                  }}
                >
                  <Play size={28} strokeWidth={1.4} className="text-gold ml-1" fill="currentColor" />
                </span>
              </button>
            )}
          </div>
        </div>
        {!playing && (
          <p
            data-testid="home-video-consent-note"
            className="mt-4 text-center font-body font-light text-[12.5px] md:text-[13px] leading-[1.7] text-muted-warm"
          >
            A lejátszással elfogadod, hogy a videó a YouTube-ról betöltődjön, és a YouTube sütiket helyezhessen el.{" "}
            <Link to="/adatkezelesi-tajekoztato#youtube" className="text-gold border-b border-gold/60 hover:opacity-80 transition-opacity duration-300">
              Részletek
            </Link>
          </p>
        )}
      </Reveal>
    </section>
  );
}
